<template>
    <el-dropdown @command="handlerSelete" class="lang-seletor">
        <img class="auth-icon-guide" src="../../../../assets/guide.svg" alt="" width="16" height="16">
        <el-dropdown-menu slot="dropdown">
            <template v-if="location.pathname === '/sn.html'">
                <el-dropdown-item v-for="(item,index) in infoList" :key="index+item.path" :command="item.path">{{item.name}}</el-dropdown-item>
            </template>
            <el-dropdown-item command="system" divided>权限申请</el-dropdown-item>
        </el-dropdown-menu>
    </el-dropdown>
</template>
<script>
import { getInfos } from './api';
import config from '@/config/user.env';
export default {
    data() {
        return {
            location: location,
            infoList: []
        };
    },
    methods: {
        handlerSelete(command) {
            if (this.infoList.length > 0) {
                this.infoList.map(item => {
                    if (command === item.path && item.openNewTagUrl) {
                        this.$router.push({
                            name: 'guidePreview',
                            query: { openNewTagUrl: item.openNewTagUrl }
                        });
                    } else if (command === item.path) {
                        this.$router.push(item.path);
                    }
                });
            }
            if (command === 'system') {
                window.open(config.MIDEA_SYSTEM);
            }
        },
        getInfoList() {
            getInfos({}).then(res => {
                if (res && res.code === '0') {
                    res.data.list.forEach(item => {
                        this.infoList.push({
                            name: item.guideName,
                            path: item.downUrl,
                            openNewTagUrl: item.downUrl
                        });
                    });
                }
            });
        }
    },
    mounted() {
        this.getInfoList();
    }
};
</script>
<style lang="less">
    .lang-seletor {
        cursor: pointer;
        margin-right: 16px;
        display: flex;
        align-items: center;
        .auth-icon-guide{
            vertical-align: middle;
        }
        .el-badge__content.is-fixed {
            right: 17px;
        }
    }
</style>
